package com.essntl.features.authentication.data.di

import org.koin.core.annotation.ComponentScan
import org.koin.core.annotation.Module

@Module
@ComponentScan("com.essntl.features.authentication.data")
class AuthenticationModule
